import { useAuth } from "@/hooks/useAuth"
import { useAuthModal } from "@/hooks/useAuthModal"
import { lumi } from "@/lib/lumi"
import { notify } from "@/lib/social"
import type { Follow } from "@/types"
import { useState } from "react"

export default function FollowButton({
  targetUserId,
  following,
  onChanged,
}: {
  targetUserId: string
  following?: Follow | null
  onChanged?: () => void
}) {
  const { user, isAuthenticated } = useAuth()
  const { openAuth } = useAuthModal()
  const [busy, setBusy] = useState(false)

  if (!targetUserId || targetUserId === user?.userId) return null

  const toggle = async () => {
    if (!isAuthenticated || !user?.userId) {
      openAuth()
      return
    }
    setBusy(true)
    try {
      if (following?._id) {
        if (following.followerId !== user.userId) return
        await lumi.entities.follows.delete(following._id)
      } else {
        const now = new Date().toISOString()
        await lumi.entities.follows.create({
          followerId: user.userId,
          followingId: targetUserId,
          creator: user.userId,
          createdAt: now,
          updatedAt: now,
        })
        await notify({ recipientId: targetUserId, actorId: user.userId, type: "follow" })
      }
      onChanged?.()
    } catch (err) {
      console.error("Follow failed:", err)
    } finally {
      setBusy(false)
    }
  }

  return (
    <button
      type="button"
      disabled={busy}
      onClick={toggle}
      className={`rounded-lg px-3 py-1.5 text-xs font-semibold disabled:opacity-60 ${
        following ? "border border-[#1F1F1F] bg-[#141414] text-white" : "bg-[#00FF66] text-black"
      }`}
    >
      {busy ? "..." : following ? "Following" : "Follow"}
    </button>
  )
}
